import { SUPPORTED_CHAINS } from 'config/constants/chains';

export const getChainTokenSymbol = (chainId?: number) => {
  if (!chainId) return '';
  const chain = SUPPORTED_CHAINS.find((row: any) => row.mainnet === chainId || row.testnet === chainId);
  if (!chain) return '';

  return chain.nativeCurrency;
};
